import React from 'react';
import { Search } from 'lucide-react';

// Threat Vector search input (prototype .tv-search): surface field with a mono feel,
// cyan focus border.
const SearchBar = ({ searchQuery, setSearchQuery, placeholder = 'Filter controls and techniques…' }) => (
  <div className="tv-search">
    <Search className="tv-search-ico" style={{ width: 16, height: 16 }} />
    <input
      type="text"
      placeholder={placeholder}
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
    />
  </div>
);

export default SearchBar;
